module.exports = __webpack_public_path__ + "img/check.e9bfcbba.png";